import { motion } from "framer-motion";
import { Wrench, Droplets, CircleGauge, Disc3, Cpu, ShieldCheck, CarFront } from "lucide-react";
import { Chapter } from "@/components/landing/Chapter";

const IMG_ENGINE =
  "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const IMG_BRAKES =
  "https://images.unsplash.com/photo-1613214150384-14921ff659b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const Card = ({ icon: Icon, title, desc, tag, span, image, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay: (index % 3) * 0.1 }}
    data-testid={`service-card-${index}`}
    className={`group relative overflow-hidden rounded-md border border-white/10 bg-[#0E1322] p-7 transition-[border-color,box-shadow,transform] duration-300 hover:border-[#0066FF]/60 hover:shadow-[0_0_40px_rgba(0,102,255,0.15)] hover:-translate-y-1 ${span}`}
  >
    {image && (
      <>
        <img
          src={image}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-25 transition-opacity duration-500 group-hover:opacity-40"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0E1322] via-[#0E1322]/60 to-transparent" />
      </>
    )}
    <div className="relative z-10 flex flex-col h-full min-h-[190px]">
      <div className="w-11 h-11 rounded-sm border border-white/10 bg-[#07090E]/70 flex items-center justify-center mb-6 transition-colors duration-300 group-hover:border-[#0066FF]/60">
        <Icon className="w-5 h-5 text-[#00E5FF]" />
      </div>
      <h3 className="font-display font-bold text-xl tracking-tight">{title}</h3>
      <p className="text-sm text-slate-400 mt-2 leading-relaxed flex-1">{desc}</p>
      <span className="mt-5 w-fit rounded-full border border-white/15 px-3 py-1 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-300">
        {tag}
      </span>
    </div>
  </motion.div>
);

const SERVICES = [
  {
    icon: Wrench,
    title: "Mécanique générale",
    desc: "Réparation moteur, distribution, embrayage, suspension. Prise en charge complète de votre véhicule, toutes marques.",
    tag: "Devis gratuit",
    span: "md:col-span-4",
    image: IMG_ENGINE,
  },
  {
    icon: Droplets,
    title: "Entretien & vidange",
    desc: "Révision constructeur, vidange, filtres, liquides. Forfaits entretien adaptés à votre carnet.",
    tag: "Garantie préservée",
    span: "md:col-span-2",
  },
  {
    icon: CircleGauge,
    title: "Pneumatiques & géométrie",
    desc: "Montage, équilibrage, permutation et parallélisme. Large choix de pneus toutes saisons.",
    tag: "Stock sur place",
    span: "md:col-span-2",
  },
  {
    icon: Disc3,
    title: "Freinage & sécurité",
    desc: "Plaquettes, disques, étriers, ABS. Contrôle complet du système de freinage pour votre sécurité.",
    tag: "Contrôle offert",
    span: "md:col-span-2",
    image: IMG_BRAKES,
  },
  {
    icon: Cpu,
    title: "Diagnostic électronique",
    desc: "Valise multimarque dernière génération : lecture des défauts, recherche de panne, voyants tableau de bord.",
    tag: "Résultat immédiat",
    span: "md:col-span-2",
  },
  {
    icon: ShieldCheck,
    title: "Pare-brise & assurance",
    desc: "Remplacement de pare-brise avec prise en charge du dossier assurance. Offre du moment : 200€ offerts pour tout changement.",
    tag: "200€ offerts",
    span: "md:col-span-3",
  },
  {
    icon: CarFront,
    title: "Vente & pièces auto",
    desc: "Véhicules neufs et d'occasion, négoce de pièces détachées et remplacement de pare-brise.",
    tag: "Sur commande",
    span: "md:col-span-3",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-24 lg:py-36 bg-[#0A0D16] border-y border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Chapter num="02" title="Nos services" accent="Entretien · Réparation · Diagnostic" />
      <div className="grid md:grid-cols-6 gap-4 lg:gap-5">
        {SERVICES.map((s, i) => (
          <Card key={s.title} {...s} index={i} />
        ))}
      </div>
    </div>
  </section>
);
